class AlberoGotsThread {
  constructor(section) {
    this.section = section;

    this.journey = section.querySelector('[data-agt-journey]');
    this.steps = [...section.querySelectorAll('[data-agt-step]')];

    this.desktopPath = section.querySelector('[data-agt-thread-path]');
    this.mobilePath = section.querySelector('[data-agt-thread-path-mobile]');

    this.outro = section.querySelector('[data-agt-outro]');
    this.outroPath = section.querySelector('[data-agt-outro-path]');

    this.desktopQuery = window.matchMedia('(min-width: 750px)');

    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    this.currentPath = null;
    this.currentLength = 0;

    /*
     * Mobil iplik için SVG clip sistemi.
     */
    this.mobileClipPath = null;
    this.mobileClipRect = null;

    this.ticking = false;

    this.init();
  }


  /* ==========================================================
     INITIALIZATION
  ========================================================== */

  init() {
    this.section.classList.add('js-ready');

    this.setupReveal();
    this.setupTitle();

    if (!this.reduceMotion) {
      this.setupThread();
      this.setupOutroThread();

      window.addEventListener(
        'scroll',
        () => this.requestUpdate(),
        { passive: true }
      );

      window.addEventListener(
        'resize',
        () => this.handleResize(),
        { passive: true }
      );
    } else {
      this.showReducedMotionState();
    }

    requestAnimationFrame(() => {
      this.update();
    });
  }


  /* ==========================================================
     TITLE
  ========================================================== */

  setupTitle() {
    const title =
      this.section.querySelector('[data-agt-title]');

    if (!title) return;

    const observer =
      new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            title.classList.add('is-visible');

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.25
        }
      );

    observer.observe(title);
  }


  /* ==========================================================
     REVEALS
  ========================================================== */

  setupReveal() {
    const items = [
      ...this.section.querySelectorAll('.agt-reveal'),
      ...this.steps
    ];

    const observer =
      new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');

            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.13
        }
      );

    items.forEach(item => {
      observer.observe(item);
    });
  }


  /* ==========================================================
     THREAD INITIALIZATION
  ========================================================== */

  setupThread() {
    /*
     * Mobil clip sistemi baştan hazırlanır.
     */
    this.setupMobileClip();

    this.selectCurrentPath();

    if (!this.currentPath) return;

    this.preparePath(this.currentPath);
  }


  selectCurrentPath() {
    this.currentPath =
      this.desktopQuery.matches
        ? this.desktopPath
        : this.mobilePath;
  }


  preparePath(path) {
    if (!path) return;

    this.currentLength =
      path.getTotalLength();

    /*
     * ========================================================
     * DESKTOP
     * ========================================================
     */

    if (path === this.desktopPath) {
      path.style.strokeDasharray =
        `${this.currentLength} ${this.currentLength}`;

      path.style.strokeDashoffset =
        `${this.currentLength}`;

      path.style.clipPath = '';

      return;
    }


    /*
     * ========================================================
     * MOBILE
     *
     * Mobilde stroke-dash kullanılmıyor.
     * Path'in tamamı çizili.
     *
     * Görünen kısmı SVG clipPath belirliyor.
     * ========================================================
     */

    if (path === this.mobilePath) {
      path.style.strokeDasharray = 'none';
      path.style.strokeDashoffset = '0';

      if (this.mobileClipPath) {
        path.setAttribute(
          'clip-path',
          `url(#${this.mobileClipPath.id})`
        );
      }
    }
  }


  /* ==========================================================
     MOBILE SVG CLIP
  ========================================================== */

  setupMobileClip() {
    if (!this.mobilePath) return;

    const svg =
      this.mobilePath.ownerSVGElement;

    if (!svg) return;

    const namespace =
      'http://www.w3.org/2000/svg';


    /*
     * Aynı section Theme Editor tarafından tekrar
     * render edilirse mevcut clip'i kullan.
     */
    const existingClip =
      svg.querySelector(
        '[data-agt-mobile-thread-clip]'
      );

    if (existingClip) {
      this.mobileClipPath = existingClip;

      this.mobileClipRect =
        existingClip.querySelector('rect');

      return;
    }


    /*
     * Section'a özel benzersiz ID.
     */
    const sectionId =
      this.section.id
        ? this.section.id.replace(
            /[^a-zA-Z0-9_-]/g,
            ''
          )
        : Math.random()
            .toString(36)
            .slice(2, 10);

    const clipId =
      `agt-mobile-thread-clip-${sectionId}`;


    /*
     * <defs>
     */
    let defs =
      svg.querySelector('defs');

    if (!defs) {
      defs =
        document.createElementNS(
          namespace,
          'defs'
        );

      svg.insertBefore(
        defs,
        svg.firstChild
      );
    }


    /*
     * <clipPath>
     */
    const clipPath =
      document.createElementNS(
        namespace,
        'clipPath'
      );

    clipPath.id = clipId;

    clipPath.setAttribute(
      'clipPathUnits',
      'userSpaceOnUse'
    );

    clipPath.setAttribute(
      'data-agt-mobile-thread-clip',
      ''
    );


    /*
     * SVG viewBox:
     *
     * 0 0 200 4200
     *
     * Kenarlarda fazladan alan bırakıyoruz.
     * Böylece stroke kalınlığı clip tarafından
     * yatayda kesilmez.
     */
    const rect =
      document.createElementNS(
        namespace,
        'rect'
      );

    rect.setAttribute('x', '-500');
    rect.setAttribute('y', '0');

    rect.setAttribute(
      'width',
      '1200'
    );

    /*
     * Başlangıçta yeşil ip görünmez.
     */
    rect.setAttribute(
      'height',
      '0'
    );


    clipPath.appendChild(rect);
    defs.appendChild(clipPath);

    this.mobileClipPath = clipPath;
    this.mobileClipRect = rect;


    /*
     * Yeşil mobil path'e clip'i bağla.
     */
    this.mobilePath.setAttribute(
      'clip-path',
      `url(#${clipId})`
    );
  }


  /* ==========================================================
     SCROLL REQUEST
  ========================================================== */

  requestUpdate() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      this.update();

      this.ticking = false;
    });
  }


  /* ==========================================================
     MAIN UPDATE
  ========================================================== */

  update() {
    if (!this.journey) return;

    this.updateThread();
    this.updateActiveSteps();
    this.updateVisualMotion();
    this.updateOutro();
  }


  /* ==========================================================
     THREAD DRAWING
  ========================================================== */

  updateThread() {
    if (
      !this.currentPath ||
      !this.currentLength
    ) {
      return;
    }

    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;


    /* ========================================================
       MOBILE
    ======================================================== */

    if (!this.desktopQuery.matches) {
      if (
        !this.mobilePath ||
        !this.mobileClipRect
      ) {
        return;
      }

      const svg =
        this.mobilePath.ownerSVGElement;

      if (!svg) return;

      const svgRect =
        svg.getBoundingClientRect();

      if (
        !svgRect.height ||
        svgRect.height <= 0
      ) {
        return;
      }


      /*
       * ======================================================
       * İPLİĞİN EKRANDA TAKİP EDECEĞİ NOKTA
       *
       * %62:
       * İplik ucu ekranın biraz alt yarısını takip eder.
       *
       * Daha aşağı istersen:
       * 0.65 / 0.68
       *
       * Daha yukarı istersen:
       * 0.58
       * ======================================================
       */

      const followLine =
        viewportHeight * 0.62;


      /*
       * Follow line'ın render edilmiş SVG içerisinde
       * bulunduğu piksel yüksekliği.
       */
      const localScreenY =
        followLine - svgRect.top;


      /*
       * SVG henüz takip çizgisine ulaşmadı.
       */
      if (localScreenY <= 0) {
        this.mobileClipRect.setAttribute(
          'height',
          '0'
        );

        return;
      }


      const viewBox =
        svg.viewBox.baseVal;

      if (
        !viewBox ||
        !viewBox.height
      ) {
        return;
      }


      /*
       * Render edilmiş SVG piksel koordinatını
       * gerçek SVG viewBox koordinatına çeviriyoruz.
       *
       * Mobil SVG:
       * viewBox="0 0 200 4200"
       *
       * preserveAspectRatio="none"
       * olduğu için dikey dönüşüm doğrusaldır.
       */
      const visibleRatio =
        this.clamp(
          localScreenY /
          svgRect.height,
          0,
          1
        );


      const visibleSvgHeight =
        viewBox.height *
        visibleRatio;


      /*
       * Clip dikdörtgeni doğrudan SVG içerisinde
       * büyüyor.
       *
       * Böylece path kıvrımlarının toplam uzunluğu
       * artık hesapta hiçbir rol oynamıyor.
       */
      this.mobileClipRect.setAttribute(
        'height',
        String(visibleSvgHeight)
      );

      return;
    }


    /* ========================================================
       DESKTOP

       Desktop tarafındaki mevcut çalışan sistemi
       değiştirmiyoruz.
    ======================================================== */

    const rect =
      this.journey.getBoundingClientRect();

    const startPoint =
      viewportHeight * 0.72;

    const totalScrollable =
      rect.height -
      viewportHeight * 0.42;

    const travelled =
      startPoint -
      rect.top;

    let progress =
      travelled /
      totalScrollable;

    progress =
      this.clamp(
        progress,
        0,
        1
      );

    const drawLength =
      this.currentLength *
      progress;

    this.currentPath.style.strokeDashoffset =
      `${
        this.currentLength -
        drawLength
      }`;
  }


  /* ==========================================================
     ACTIVE STEPS
  ========================================================== */

  updateActiveSteps() {
    const activationLine =
      window.innerHeight * 0.55;

    this.steps.forEach(step => {
      const rect =
        step.getBoundingClientRect();

      const stepCenter =
        rect.top +
        rect.height * 0.45;

      if (
        stepCenter <=
        activationLine
      ) {
        step.classList.add(
          'is-active'
        );
      } else {
        step.classList.remove(
          'is-active'
        );
      }
    });
  }


  /* ==========================================================
     VISUAL MOTION
  ========================================================== */

  updateVisualMotion() {
    this.steps.forEach(
      (step, index) => {
        const visual =
          step.querySelector(
            '.agt__visual'
          );

        /*
         * Hem IMG hem .agt__art yapısını
         * destekliyor.
         */
        const image =
          step.querySelector(
            '.agt__image, .agt__art'
          );

        const blob =
          step.querySelector(
            '.agt__blob'
          );

        if (!visual) return;

        const rect =
          step.getBoundingClientRect();

        const viewportHeight =
          window.innerHeight;

        const center =
          rect.top +
          rect.height / 2;

        const distance =
          center -
          viewportHeight / 2;

        const normalized =
          this.clamp(
            distance /
            viewportHeight,
            -1,
            1
          );

        /*
         * İllüstrasyon hafif parallax.
         */
        const imageY =
          normalized * -14;

        /*
         * Blob ters yönde hareket eder.
         */
        const blobY =
          normalized * 21;

        const rotation =
          normalized *
          (
            index % 2 === 0
              ? 1.6
              : -1.6
          );


        if (image) {
          image.style.transform =
            `translate3d(
              0,
              ${imageY}px,
              0
            )
            rotate(
              ${rotation}deg
            )`;
        }


        if (blob) {
          blob.style.transform =
            `translate3d(
              0,
              ${blobY}px,
              0
            )
            rotate(
              ${-rotation * 1.5}deg
            )`;
        }
      }
    );
  }


  /* ==========================================================
     OUTRO THREAD
  ========================================================== */

  setupOutroThread() {
    if (!this.outroPath) return;

    const length =
      this.outroPath.getTotalLength();

    this.outroPath.dataset.pathLength =
      length;

    this.outroPath.style.strokeDasharray =
      `${length} ${length}`;

    this.outroPath.style.strokeDashoffset =
      `${length}`;
  }


  updateOutro() {
    if (
      !this.outro ||
      !this.outroPath
    ) {
      return;
    }

    const rect =
      this.outro.getBoundingClientRect();

    const viewportHeight =
      window.innerHeight;

    const progress =
      this.clamp(
        (
          viewportHeight -
          rect.top
        ) /
        (
          viewportHeight *
          0.8
        ),
        0,
        1
      );

    const length =
      Number(
        this.outroPath.dataset.pathLength
      );

    if (!length) return;

    this.outroPath.style.strokeDashoffset =
      `${
        length -
        length * progress
      }`;
  }


  /* ==========================================================
     RESIZE
  ========================================================== */

  handleResize() {
    const previousPath =
      this.currentPath;

    this.selectCurrentPath();


    /*
     * Desktop ↔ mobile breakpoint
     * değişti.
     */
    if (
      previousPath !==
        this.currentPath &&
      this.currentPath
    ) {
      this.preparePath(
        this.currentPath
      );
    }


    /*
     * Aynı breakpoint içerisindeki resize /
     * Safari viewport yüksekliği değişimleri
     * doğrudan updateThread tarafından yeniden
     * hesaplanır.
     */
    this.requestUpdate();
  }


  /* ==========================================================
     REDUCED MOTION
  ========================================================== */

  showReducedMotionState() {
    this.steps.forEach(step => {
      step.classList.add(
        'is-visible',
        'is-active'
      );
    });

    this.section
      .querySelectorAll(
        '.agt-reveal'
      )
      .forEach(item => {
        item.classList.add(
          'is-visible'
        );
      });

    const title =
      this.section.querySelector(
        '[data-agt-title]'
      );

    if (title) {
      title.classList.add(
        'is-visible'
      );
    }


    /*
     * Reduced motion aktifse iplikleri
     * tamamen görünür bırak.
     */
    if (this.desktopPath) {
      this.desktopPath.style.strokeDasharray =
        'none';

      this.desktopPath.style.strokeDashoffset =
        '0';
    }

    if (this.mobilePath) {
      this.mobilePath.style.strokeDasharray =
        'none';

      this.mobilePath.style.strokeDashoffset =
        '0';

      this.mobilePath.removeAttribute(
        'clip-path'
      );
    }
  }


  /* ==========================================================
     UTILITY
  ========================================================== */

  clamp(value, min, max) {
    return Math.min(
      Math.max(
        value,
        min
      ),
      max
    );
  }
}


/* ============================================================
   INITIALIZE
============================================================ */

function initAlberoGotsThreads(
  root = document
) {
  root
    .querySelectorAll(
      '[data-albero-gots-thread]'
    )
    .forEach(section => {

      /*
       * Aynı section'ın iki kez initialize
       * edilmesini engelle.
       */
      if (
        section.dataset
          .agtInitialized
      ) {
        return;
      }

      section.dataset
        .agtInitialized =
        'true';

      new AlberoGotsThread(
        section
      );
    });
}


/* ============================================================
   NORMAL PAGE LOAD
============================================================ */

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initAlberoGotsThreads();
    }
  );
} else {
  initAlberoGotsThreads();
}


/* ============================================================
   SHOPIFY THEME EDITOR
============================================================ */

document.addEventListener(
  'shopify:section:load',
  event => {
    initAlberoGotsThreads(
      event.target
    );
  }
);